
interface ShowProps {
  when?: unknown;
  fallback?: React.ReactNode;
  children?: React.ReactNode;
  keyed?: false;
}
interface ShowPropsKeyed<T> {
  when?: T;
  fallback?: React.ReactNode;
  children?: (when: NonNullable<T>) => React.ReactNode;
  keyed: true
}
const Show = <T,>(props: ShowProps | ShowPropsKeyed<T>) => {
  if (props.keyed && !!props.when) {
    return props.children?.(props.when);
  }
  if (props.when) {
    return <>{props.children}</>;
  }
  if (props.fallback) {
    return <>{props.fallback}</>;
  }
};
export default Show;
